import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function hasAccountDeactivationFeedback(): Promise<boolean> {
  const res = await Api.Routes.UserFeedback.accountDeactivationStatus();
  return res.hasSubmitted;
}

export async function fetchUserFeedbackById(params: {
  id: number;
}): Promise<Components.Schemas.DetailedUserFeedbackDto> {
  const res = await Api.Routes.UserFeedback.retrieveById({ id: params.id });
  return res.data;
}

export async function createUserFeedback(
  dto: Components.Schemas.CreateUserFeedbackDto,
): Promise<Components.Schemas.UserFeedbackDto> {
  const res = await Api.Routes.UserFeedback.create({}, dto);
  return res.data;
}

export async function updateUserFeedback(params: {
  id: number;
  dto: Components.Schemas.UpdateUserFeedbackDto;
}): Promise<Components.Schemas.UserFeedbackDto> {
  const res = await Api.Routes.UserFeedback.update({ id: params.id }, params.dto);
  return res.data;
}

export async function shouldSeeRatingPrompt(params: {
  id: number;
}): Promise<Components.Schemas.UserShouldSeeRatingPromptResponseDto> {
  const res = await Api.Routes.UserFeedback.shouldSeeRatingPrompt({ id: params.id });
  return res;
}
